import React from "react";
import "./loaderComponent.css";

function LoaderComponent({ size }) {
  return (
    <div className={"LoaderComponent " + size}>
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default LoaderComponent;
